// extracted by mini-css-extract-plugin
export default {"description":"COADescription-module--description--87188","white":"COADescription-module--white--90abe"};